import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PRODUCT_KEYS, PRODUCTS } from "@/data/packs";
import { ZoomImage } from "@/components/ZoomImage";

export const ProductRange = () => {
  return (
    <section id="gamme" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
      <div className="max-w-2xl mb-10">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-3">
          La gamme Ozentya
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl font-medium tracking-tight text-[var(--oz-text)]">
          Cinq soins d'exception dans chaque pack
        </h2>
        <p className="mt-4 text-base text-[var(--oz-muted)] leading-relaxed">
          Des formules riches en actifs naturels, pensées pour les cheveux texturés. Survolez une
          photo pour la zoomer et cliquez pour découvrir la fiche détaillée.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {PRODUCT_KEYS.map((key) => {
          const p = PRODUCTS[key];
          return (
            <div
              key={key}
              data-testid={`range-product-${key}`}
              className="bg-white rounded-2xl border border-[var(--oz-border)] overflow-hidden flex flex-col hover:shadow-[0_20px_40px_-24px_rgba(26,23,20,0.45)] transition-shadow"
            >
              <ZoomImage
                src={p.image}
                alt={p.name}
                zoom={2}
                className="aspect-square bg-[var(--oz-bg-2)]"
                testId={`range-zoom-${key}`}
              />
              <div className="p-3.5 flex flex-col flex-1">
                <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--oz-gold)]">
                  {p.tagline}
                </span>
                <h3 className="mt-1 text-sm font-semibold text-[var(--oz-text)] leading-tight">{p.name}</h3>
                <p className="mt-2 text-xs text-[var(--oz-muted)] leading-relaxed line-clamp-3 flex-1">
                  {p.intro}
                </p>
                <Link
                  to={`/produit/${key}`}
                  data-testid={`range-link-${key}`}
                  className="mt-3 inline-flex items-center gap-1.5 py-2 text-xs font-semibold text-[var(--oz-text)] hover:text-[var(--oz-gold)] transition-colors"
                >
                  Voir la fiche <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ProductRange;
